<template>
  <!-- 滚动容器 -->
  <div
    class="scroll-container"
    ref="scrollContainer"
    @scroll="handleScrollDebounced"
  >
    <!-- 列表内容 - 现在渲染全部数据（不再使用虚拟滚动） -->
    <div
      v-for="item in allItems"
      :key="item.id || `skeleton-${item._id}`"
      class="item"
      :ref="`item-${item.id}`"
    >
      <!-- 真实数据 -->
      <template v-if="item.id">
        <p>
          {{ item.content }}
        </p>
        <div v-if="item.type == 'radio'">
          <el-radio-group v-model="item.input">
            <el-radio label="RA">备选项A</el-radio>
            <el-radio label="RB">备选项B</el-radio>
            <el-radio label="RC">备选项C</el-radio>
          </el-radio-group>
        </div>
        <div v-if="item.type == 'multiple'">
          <el-checkbox-group v-model="item.input">
            <el-checkbox label="checkA">复选框A</el-checkbox>
            <el-checkbox label="checkB">复选框B</el-checkbox>
            <el-checkbox label="checkC">复选框C</el-checkbox>
          </el-checkbox-group>
        </div>
        <div v-if="item.type == 'text'">
          <el-input v-model="item.input" placeholder="请输入内容"></el-input>
        </div>
        <div v-if="item.type == 'textarea'">
          <div style="margin: 20px 0"></div>
          <el-input
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4 }"
            placeholder="请输入内容"
            v-model="item.input"
          >
          </el-input>
        </div>
      </template>
      <!-- 骨架屏占位 -->
      <div v-else class="skeleton">
        <div class="skeleton-line"></div>
        <div class="skeleton-line short"></div>
      </div>
    </div>

    <!-- 加载状态 -->
    <div v-if="loading" class="loading">
      <div class="skeleton">
        <div class="skeleton-line"></div>
        <div class="skeleton-line short"></div>
      </div>
    </div>

    <!-- 没有更多数据的提示 -->
    <div v-if="noMore" class="no-more">
      <p>没有更多了（共 {{ totalItems }} 条数据，限制 {{ max_items }} 条）</p>
      <div>
        <el-tag
          v-for="(item, index) in nullArr"
          :key="index"
          @click.stop="clickTag(item)"
          >{{ item }}</el-tag
        >
      </div>
      <div>
        <el-button @click="submit()">提交</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { debounce } from "lodash-es";

export default {
  data() {
    return {
      allItems: [], // 所有数据
      page: 1, // 当前页码
      loading: false, // 是否正在加载中
      noMore: false, // 是否没有更多数据
      skeletonCount: 0, // 骨架屏计数器（用于生成唯一ID）
      totalItems: 0, // 已加载的总数据量
      max_items: 10, //最大加载数据量限制
      nullArr: [],
    };
  },

  created() {
    /**
     * 创建防抖函数实例
     * 使用lodash的debounce，延迟100ms执行
     * 避免滚动事件频繁触发导致的性能问题
     */
    this.handleScrollDebounced = debounce(this.handleScroll, 100);
  },

  mounted() {
    // 初始加载数据
    this.loadMore();
  },

  beforeDestroy() {
    /**
     * 组件销毁前取消防抖函数
     * 防止组件销毁后函数仍被执行
     */
    this.handleScrollDebounced.cancel();
  },

  computed: {
    /**
     * 计算是否已达到最大数据量限制
     * @return {boolean} 是否已达到限制
     */
    reachedMaxItems() {
      return this.totalItems >= this.max_items;
    },
  },

  methods: {
    clickTag(itemId) {
      this.scrollToItem(itemId);
    },

    /**
     * 滚动到指定ID的列表项
     * @param {number} itemId - 要滚动到的项目ID
     */
    scrollToItem(itemId) {
      // 等待DOM更新
      this.$nextTick(() => {
        const container = this.$refs.scrollContainer;
        const itemRef = this.$refs[`item-${itemId}`];

        if (itemRef && itemRef[0]) {
          const itemElement = itemRef[0];
          // 计算目标位置（项目相对于容器的位置）
          const targetPosition = itemElement.offsetTop - container.offsetTop;

          // 先检查是否已经在目标位置附近
          if (container.scrollTop - targetPosition < 5) {
            // 已经在目标位置，直接高亮
            this.highlightItem(itemElement);
            return;
          }

          // 移除可能存在的旧监听器
          const onScrollComplete = () => {
            // 检查是否已经滚动到目标位置附近
            if (Math.abs(container.scrollTop - targetPosition) < 5) {
              // 滚动完成，添加高亮效果
              this.highlightItem(itemElement);
              // 移除监听器
              container.removeEventListener("scroll", onScrollComplete);
            }
          };

          // 添加滚动监听器
          container.addEventListener("scroll", onScrollComplete);

          // 开始平滑滚动
          container.scrollTo({
            top: targetPosition,
            behavior: "smooth",
          });

          // 如果浏览器不支持平滑滚动，立即执行高亮
          if (!("scrollBehavior" in document.documentElement.style)) {
            setTimeout(() => {
              this.highlightItem(itemElement);
            }, 100);
          }
        }
      });
    },

    // 新增的高亮方法
    highlightItem(element) {
      element.classList.add("highlight");
      setTimeout(() => {
        element.classList.remove("highlight");
      }, 1000);
    },
    submit() {
      let data = JSON.parse(JSON.stringify(this.allItems));
      let json2 = data.filter((item) => this.isEmptyInput(item));
      let arr = json2.map((item) => item.id);
      let data_obj = data.reduce((acc, item) => {
        acc[item.id] = item.input;
        return acc;
      }, {});
      this.nullArr = arr;
      console.log("aa:" + JSON.stringify(data_obj));
    },
    isEmptyInput(item) {
      if (item.type === "multiple") {
        // 多选题类型，检查数组是否为空
        return item.input.length === 0;
      } else {
        // 其他类型，检查字符串是否为空
        return item.input === "";
      }
    },
    /**
     * 滚动事件处理函数（防抖后）
     */
    handleScroll() {
      const container = this.$refs.scrollContainer;

      /**
       * 判断是否滚动到底部（距离底部100px以内视为触底）
       * scrollTop: 已滚动的距离
       * clientHeight: 容器可视高度
       * scrollHeight: 容器总高度（包括滚动区域）
       */
      if (
        container.scrollTop + container.clientHeight >=
        container.scrollHeight - 100
      ) {
        this.loadMore();
      }
    },

    /**
     * 加载更多数据
     */
    async loadMore() {
      // 如果正在加载、没有更多数据或已达到最大限制，则不再加载
      if (this.loading || this.noMore || this.reachedMaxItems) {
        // 如果是因为达到最大限制而停止加载，确保noMore状态正确
        if (this.reachedMaxItems) {
          this.noMore = true;
        }
        return;
      }

      // 设置加载状态
      this.loading = true;

      try {
        // 计算本次还能加载的数量（不超过this.max_items限制）
        const remaining = this.max_items - this.totalItems;
        const loadCount = Math.min(10, remaining); // 每次最多加载10条

        /**
         * 先添加骨架屏占位项
         * 提升用户体验，让用户感知内容正在加载
         */
        const skeletonItems = Array(loadCount)
          .fill(0)
          .map(() => ({
            _id: `skeleton-${this.skeletonCount++}`, // 生成唯一ID
            id: null, // 真实数据加载后会替换为真实ID
            content: null, // 真实数据加载后会替换为真实内容
          }));
        this.allItems = [...this.allItems, ...skeletonItems];

        // 模拟API请求获取数据
        const newItems = await this.fetchData(this.page, loadCount);

        // 如果没有获取到数据或已达到最大限制，设置没有更多数据
        if (newItems.length === 0 || this.reachedMaxItems) {
          this.noMore = true;
          // 移除骨架屏占位
          this.allItems = this.allItems.filter((item) => item.id !== null);
          return;
        }

        // 更新已加载的总数据量
        this.totalItems += newItems.length;

        /**
         * 用真实数据替换骨架屏占位
         * splice参数：
         *   - 开始位置：数组长度 - 加载数量（即骨架屏位置）
         *   - 删除数量：加载数量（骨架屏数量）
         *   - 插入内容：新加载的数据
         */
        this.allItems.splice(
          this.allItems.length - loadCount,
          loadCount,
          ...newItems
        );

        // 页码增加
        this.page++;

        // 检查是否已达到最大限制
        if (this.reachedMaxItems) {
          this.noMore = true;
        }
      } catch (error) {
        console.error("数据加载失败:", error);
        // 出错时也移除骨架屏占位
        this.allItems = this.allItems.filter((item) => item.id !== null);
      } finally {
        // 无论成功失败，最后都取消加载状态
        this.loading = false;
      }
    },

    /**
     * 模拟API请求函数
     * @param {number} page - 当前页码
     * @param {number} count - 需要加载的数量
     * @return {Promise} 返回模拟数据
     */
    fetchData(page, count = 10) {
      return new Promise((resolve) => {
        // 模拟网络延迟（800ms）
        setTimeout(() => {
          // 生成模拟数据
          const newItems = Array(count)
            .fill(0)
            .map((_, i) => {
              // 计算项目ID（基于页码和索引）
              const itemId = (page - 1) * 10 + i + 1;
              let data = {
                id: itemId,
                type: this.getRandomType(),
                content: `项目 ${itemId} - ${this.getRandomContent()}`,
              };
              if (data.type == "multiple") {
                data.input = [];
              } else {
                data.input = "";
              }
              return data;
            });
          resolve(newItems);
        }, 800);
      });
    },

    /**
     * 生成随机内容（用于模拟数据）
     * @return {string} 随机文本
     */
    getRandomContent() {
      const texts = [
        "基础无限滚动实现",
        "防抖处理优化性能",
        "骨架屏提升用户体验",
        "数据量限制功能",
        "详细注释说明",
      ];
      return texts[Math.floor(Math.random() * texts.length)];
    },
    getRandomType() {
      const texts = ["radio", "multiple", "text", "textarea"];
      return texts[Math.floor(Math.random() * texts.length)];
    },
  },
};
</script>

<style scoped>
/* 更明显的闪烁动画 */
@keyframes strong-blink {
  0%,
  100% {
    background-color: transparent;
  }
  25%,
  75% {
    background-color: rgba(255, 0, 0, 0.842);
  }
  50% {
    background-color: rgba(255, 17, 0, 0.425);
  }
}

.highlight {
  animation: strong-blink 1s ease 3; /* 快速闪烁4次，每次0.5秒 */
}
/* 滚动容器样式 */
.scroll-container {
  height: 500px; /* 固定高度 */
  overflow-y: scroll; /* 启用垂直滚动 */
  scrollbar-width: none; /* Firefox隐藏滚动条 */
  -ms-overflow-style: none; /* IE/Edge隐藏滚动条 */
  border: 1px solid #eee; /* 边框 */
}

/* Chrome/Safari隐藏滚动条 */
.scroll-container::-webkit-scrollbar {
  display: none;
}

/* 列表项样式 */
.item {
  /*height: 60px; */ /* 固定高度 */
  padding: 10px; /* 内边距 */
  border-bottom: 1px solid #eee; /* 底部边框 */
  box-sizing: border-box; /* 盒模型计算方式 */
}

/* 加载中和没有更多数据的样式 */
.loading,
.no-more {
  /* height: 60px;  与列表项同高 */
  display: flex; /* 弹性布局 */
  flex-direction: column;
  align-items: center; /* 垂直居中 */
  justify-content: center; /* 水平居中 */
  color: #999; /* 文字颜色 */
}

/* 骨架屏样式 */
.skeleton {
  padding: 10px; /* 内边距 */
}

/* 骨架屏线条 */
.skeleton-line {
  height: 16px; /* 高度 */
  background: linear-gradient(
    90deg,
    #f0f0f0 25%,
    #e0e0e0 50%,
    #f0f0f0 75%
  ); /* 渐变背景 */
  background-size: 200% 100%; /* 背景大小 */
  animation: shimmer 1.5s infinite; /* 动画效果 */
  border-radius: 4px; /* 圆角 */
  margin-bottom: 8px; /* 下边距 */
}

/* 短线条 */
.skeleton-line.short {
  width: 60%; /* 宽度60% */
}

/* 骨架屏闪烁动画 */
@keyframes shimmer {
  0% {
    background-position: 200% 0; /* 背景位置初始状态 */
  }
  100% {
    background-position: -200% 0; /* 背景位置结束状态 */
  }
}
</style>
